import script from "./FingerPrintLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./FingerPrintLogin.vue?vue&type=script&setup=true&lang=js"

import "./FingerPrintLogin.vue?vue&type=style&index=0&id=3dd08d2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dd08d2a"]])

export default __exports__